import React, { Component } from 'react';
import 'Styles/usersView/users.scss';
import UsersStore from 'Stores/usersStore';
import { observer } from 'mobx-react';
import UserLine from 'Components/UsersView/userLine';
import SmrTable from "Components/Common/SmrTable";
import { ShowModal, CloseModal } from 'Utils/CommonFunctions';
import SyncSyncedProcessModal from "Components/UsersView/syncSyncedProcessModal";
import EndOfSyncProcessModal from "Components/UsersView/endOfSyncProcessModal";
import MultiButton from "Components/Common/multiButton";
import SelectUsersToSyncModal from "Components/UsersView/selectUsersToSyncModal";
import { Link } from 'react-router-dom';

class UsersTable extends Component {
    constructor(props) {
        super(props);

        UsersStore.InitModalHandlers(
            this.ShowSyncSyncedProcessModal,
            this.ShowSyncSyncedResultModal,
            this.CloseSyncSyncedProcessModal
        );
    }

    // componentDidMount() { }
    // componentWillUnmount() { }

    searchNewUsers(pageToSet) {
        if (pageToSet == null)
            pageToSet = 1;

        UsersStore.GetUsers(UsersStore.searchAlias, pageToSet);
    }

    ShowSyncSyncedProcessModal() {
        ShowModal({
            getHeader: () => UsersStore.GetSyncModalTitle(),
            canBeClosed: false,
            className: 'sync-synced-process-modal',
            children: <SyncSyncedProcessModal />,
            getButtons: () => UsersStore.GetButtonsSyncSyncedProcessModal()
        });
    }

    CloseSyncSyncedProcessModal() {
        CloseModal();
    }

    ShowSyncSyncedResultModal() {
        ShowModal({
            getHeader: () => UsersStore.GetSyncModalTitle(),
            className: 'sync-synced-result-modal',
            canBeClosed: false,
            children: <EndOfSyncProcessModal usersReloadResult={UsersStore.usersReloadResult} />,
            buttons: [{
                className: 'blue-button',
                content: 'Закрыть',
                closer: true,
                onClick: UsersStore.ClearResyncUsersResult.bind(UsersStore)
            }]
        })
    }

    ShowPromptSelectUsersToSyncModal() {
        if (UsersStore.IsCanSync() == false)
            return;

        UsersStore.ClearStoreSelectSyncUsersModal();
        UsersStore.SelectUsersToSyncModalLoadUsersCanSync();

        ShowModal({
            width: '50%',
            canBeClosed: true,
            header: 'Синхронизация пользователей',
            children: 'Данная операция запустит процесс синхронизации выбранных пользователей. Процесс загрузки и обновления данных может занять продолжительное время и активно использует ресурсы сервера. Во время выполнения синхронизации профили пользователей будут заблокированы для редактирования. Рекомендуется выполнять её в нерабочее время. Хотите продолжить?',
            buttons: [
                {
                    closer: true,
                    content: 'Отменить'
                },
                {
                    closer: false,
                    content: 'Продолжить',
                    onClick: _ =>
                        ShowModal({
                            width: '70%',
                            height: '620px',
                            canBeClosed: true,
                            header: 'Активировать и синхронизировать пользователей',
                            children: <SelectUsersToSyncModal />,
                            buttonsStyleJustifyContent: "flex-end",
                            getButtons: () => [
                                {
                                    closer: true,
                                    content: 'Отменить',
                                    onClick: _ => UsersStore.selectSyncUsersModalData.selectedUsersLids = []
                                },
                                {
                                    closer: false,
                                    content: 'Отменить всех',
                                    onClick: _ => UsersStore.selectSyncUsersModalData.selectedUsersLids = []
                                },
                                {
                                    closer: false,
                                    content: 'Выбрать всех',
                                    onClick: _ => UsersStore.selectSyncUsersModalData.selectedUsersLids = Object.keys(UsersStore.selectSyncUsersModalData.usersNamesByLids)
                                },
                                {
                                    closer: true,
                                    className: "blue-button " + ((
                                        (
                                            UsersStore.selectSyncUsersModalData.receiveDocumentsFromIsNeeded == false
                                            ||
                                            UsersStore.selectSyncUsersModalData.receiveDocumentsFrom
                                        )
                                        &&
                                        UsersStore.selectSyncUsersModalData.selectedUsersLids.length > 0)
                                        ? null
                                        : "disabled"
                                    ),
                                    content: 'Активировать',
                                    onClick: UsersStore.SelectUsersToSyncModalSyncSelectedUsersClick.bind(UsersStore)
                                },
                            ]
                        })
                }
            ]
        });
    }

    SyncSyncedUsers() {
        if (UsersStore.IsCanSync() == false)
            return;
        UsersStore.SyncSyncedUsers();
    }

    cleanTableData() {
        UsersStore.tableStore.CleanStore()
    }

    /** @param {WebUser} user  */
    renderTableLine(user) {
        return (
            <UserLine
                key={user.id}
                user={user}
                userId={user.id}
                userLid={user.lid}
            />
        );
    }

    renderHeader() {
        return (
            <div className="header">
                <span>ФИО</span>
                <input id="users-search" placeholder="Поиск по ФИО" value={UsersStore.searchAlias} onChange={e => {
                    UsersStore.searchAlias = e.target.value;
                    this.searchNewUsers()
                }} />
            </div>
        );
    }

    render() {
        let tableButtonsPanel = {
            left: [
                <MultiButton title='Управление пользователями'
                    id='sync-users-button'
                    menuButtonsMinWidth='310px'
                    buttons={[{
                        disabled: false,
                        title: 'Повторно синхронизировать всех',
                        onClick: this.SyncSyncedUsers
                    }, {
                        disabled: false,
                        title: 'Активировать пользователей',
                        onClick: this.ShowPromptSelectUsersToSyncModal
                    }]}
                    key={'protocol-multi-button'}
                />
            ],
            right: [
                <Link to={`${window.SmrLocation}/users/serversettings`}>
                    <button
                        key='user-table-buttons-panel-left-legend-button'
                        className='user-serversettings-button'>
                        Пользовательские настройки
                    </button>
                </Link>
            ],
        }

        return (
            <div className='users-table-container'>
                <SmrTable className="users-table"
                    loading={UsersStore.usersLoading}
                    renderTableLine={this.renderTableLine.bind(this)}
                    cleanTableData={this.cleanTableData.bind(this)}
                    renderHeader={this.renderHeader.bind(this)}
                    getDataPage={this.searchNewUsers.bind(this)}
                    location={this.props.location}
                    buttonsPanel={tableButtonsPanel}
                    setTableStore={UsersStore.SetTableStore.bind(UsersStore)}
                    cleanTableStore={UsersStore.CleanTableStore.bind(UsersStore)} />
            </div>
        );
    }
}

export default observer(UsersTable);